<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`">
    <BlockSymbol
      v-if="vars.blockPositionText"
      :position-text="blockPosition"
      :image-class="`tw-max-w-[80%] md:tw-max-w-[40%] lg:tw-max-w-[60%]`"
      :block-logo-image="String(vars?.blockLogoImage)"
    />
    <div class="container">
      <div class="tw-max-w-4xl ">
        <!-- Title -->
        <h2 
          v-if="vars.titleText" 
          class="tw-mb-12"
          :style="`color: var(--c-${vars.textColor});`"
        >
          {{ vars.titleText }}
        </h2>

        <!-- Case Study Details -->
        <div class="tw-space-y-6">
          <div 
            v-for="(item, index) in items" 
            :key="item.key || `item-${index}`"
            class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-start tw-gap-2 lg:tw-gap-8"
          >
            <div 
              class="tw-flex-shrink-0 tw-font-bold tw-text-sm lg:tw-text-base tw-tracking-wide lg:tw-w-96"
              :style="`color: var(--c-${vars.textColor});`"
            >
              {{ item.key }}
            </div>
            <div 
              class="tw-flex-grow tw-text-sm lg:tw-text-base tw-opacity-90"
              :style="`color: var(--c-${vars.textColor});`"
            >
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app';
import { ComponentMixin } from '~/mixins/component.mixin';
import CaseStudyCard from './CaseStudyCard.vue';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'CaseStudySummary',

  components: {
    CaseStudyCard,
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  computed: {
    items() {
      return this.groupedVariables?.items || [];
    },

    blockPosition(): string {
      // Mobile'da mobile_bottom_center, desktop'ta orijinal pozisyon
      if (process.client && window.innerWidth < 1024) {
        return 'mobile_bottom_center';
      }
      return String(this.vars?.blockPositionText || '');
    },
  },
});
</script>
